import { render, staticRenderFns } from "./XacTrung.vue?vue&type=template&id=7646f26b&"
import script from "./XacTrung.vue?vue&type=script&lang=js&"
export * from "./XacTrung.vue?vue&type=script&lang=js&"
import style0 from "./XacTrung.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports